import React from "react";
import { Link } from "react-router-dom";

import { handleGetLanguage } from "../utils/languageStorage";

export default function Footer() {
    const language = handleGetLanguage();

    const translations = {
        ka: {
            about: 'ჩვენს შესახებ',
            rules: 'წესები და პირობები',
            delivery: 'მიწოდების პირობები',
            contact: 'კონტაქტი'
        },
        en: {
            about: 'About Us',
            rules: 'Rules',
            delivery: 'Terms of delivery',
            contact: 'Contact'
        }
    };
    
    const links = [
        { id: 0, to: "/career", key: "about" },
        { id: 1, to: "/rules", key: "rules" },
        { id: 2, to: "/delivery", key: "delivery" },
        { id: 3, to: "/contact", key: "contact" }
    ];

    return (
        <footer className="bottom-0 pt-5 footer bg-dark-footer  text-gray-200 dark:text-gray-200">
            <div className="container mx-auto px-4 md:px-0 text-center flex sm:hidden flex-col items-center">
                <Link to="#" className="text-[22px] focus:outline-none">
                    <h1 className="text-2xl text-white">OnlyBrands</h1>
                </Link>
                <div className="flex flex-col gap-2 mt-4">
                    {links.map((link) => (
                        <Link to={link.to} className="focus:outline-none" key={link.id}>
                            <p className="text-white md:text-base text-sm">
                                {translations[language][link.key]}
                            </p>
                        </Link>
                    ))}
                </div>

            </div>

            <div className="container mx-auto px-4 md:px-0 text-center hidden sm:flex  items-center justify-between w-full ">
            <div className="flex flex-1 justify-around gap-2 ">
                    {links.slice(0, 2).map((link) => (
                        <Link to={link.to} className="focus:outline-none" key={link.id}>
                            <p className="text-white md:text-base text-sm">
                                {translations[language][link.key]}
                            </p>
                        </Link>
                    ))}
                </div>
                <Link to="#" className="text-[22px] focus:outline-none">
                    <h1 className="text-2xl text-white">OnlyBrands</h1>
                </Link>
                <div className="flex flex-1 justify-around  gap-2 ">
                    {links.slice(2, 4).map((link) => (
                        <Link to={link.to} className="focus:outline-none" key={link.id}>
                            <p className="text-white md:text-base text-sm">
                                {translations[language][link.key]}
                            </p>
                        </Link>
                    ))}
                </div>

            </div>

            <div className="py-6 px-4 md:px-0 border-t border-slate-800">
                <div className="container mx-auto text-center md:flex md:justify-between">
                    <Link
                        to={"https://quantum-soft.org"}
                        className="mb-2 md:mb-0 text-gray-400 text-xs md:text-sm"
                    >
                        Developed by QSOFT - Quantum Soft
                    </Link>
                    <p className="mb-2 md:mb-0 font-bold text-xs md:text-sm">
                        Copyright © 2023 - 2024 onlybrands.ge. ყველა უფლება დაცულია.
                    </p>
                    <p className="text-gray-400 text-xs md:text-sm">
                        Website Protected By <Link to="https://quantum-security.org">QSEC</Link>
                    </p>
                </div>
            </div>
        </footer>
    );
}
